<template>
    <div class="resize-calendar-parent date-range calendar-datepicker">
        <div class="date-range__pickers">
            <div
                class="date-range__picker date-range__picker--start date-range__picker--end resize-calendar"
                @click.stop
            >
                <v-date-picker
                    ref="datepickerref"
                    :value="value"
                    :weekday-format="getDay"
                    :events="dateRange.dates"
                    :event-color="dateRange.colors"
                    :locale="locale"
                    :locale-first-day-of-year="firstDayOfYear"
                    :first-day-of-week="firstDayOfWeek"
                    reactive
                    show-week
                    class="elevation-0"
                    multiple
                    no-title
                    scrollable
                    @click:date="emitInput"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch, computed } from "@vue/composition-api";
import { $t } from "../../i18n";
import AppModule from '../../store/modules/app'
import {formatSysDate, parseSysDate} from "@/plugins/formatting";

export default {
    name: "CalendarDatePicker",
    props: {
        value: {
            type: Array,
            default: () => {}
        }
    },
    setup(props, ctx) {
        const { formatting } = AppModule();
        const datepickerref = ref(null);
        const dateRange = ref({
            dates: [],
            colors: {}
        });
        const getDay = date => {
            const daysOfWeek = [$t("Su"), $t("Mo"), $t("Tu"), $t("We"), $t("Th"), $t("Fr"), $t("Sa")];
            let i = new Date(date).getDay(date);
            return daysOfWeek[i];
        };
        const addDays = (date, days) => {
            const result = parseSysDate(date);
            result.setDate(result.getDate() + days);
            return formatSysDate(result);
        };
        const value = computed(() => props.value);

        const locale = computed(function() {
            return formatting.value.culture;
        });

        const firstDayOfYear = computed(function() {
            return formatting.value.locale_first_day_of_year
        })

        const firstDayOfWeek = computed(function() {
            // TODO: currently our first_week_day is 7 if it is starting on sunday, however this offsets the week numbers by 1
            // I believe vuetify instead wants 0 and this change should technically be done in the backend where we send first_week_day
            // However that requires testing the rest of the system, so this is just a safe hack
            return formatting.value.first_week_day % 7
        })

        const setInRangeData = val => {
            const inRangeData = {
                dates: [],
                colors: {}
            };
            const date0 = parseSysDate(val[0]);
            const date1 = parseSysDate(val[1]);

            let startDate = date0 <= date1 ? date0 : date1;
            let endDate = date1 >= date0 ? date1 : date0;
            const diffDays = (endDate - startDate) / (1000 * 3600 * 24);
            for (let i = 0; i <= diffDays; i += 1) {
                const date = addDays(formatSysDate(startDate), i);
                inRangeData.dates.push(date);
                inRangeData.colors[date] = `date-range__date-in-range blue lighten-5`;
                if (i === 0) inRangeData.colors[date] += " date-range__range-start";
                if (i === diffDays) inRangeData.colors[date] += " date-range__range-end";
            }
            dateRange.value = Object.assign({}, dateRange.value, inRangeData);
        };
        const test = ref([]);
        watch(value, val => {
            if (val) {
                test.value = val;
                setInRangeData(val);
            }
        });
        const emitInput = ev => {
            ctx.emit("input", ev);
        };
        return {
            test,
            dateRange,
            emitInput,
            getDay,
            datepickerref,
            locale,
            firstDayOfWeek,
            firstDayOfYear
        };
    }
};
</script>

<style scoped lang="scss">
::v-deep .v-date-picker-table {
    padding-left: 8px;
    padding-right: 8px;
}
</style>
